import type { eq } from '@code-expert/prelude';
import { adt, iots, nat, string } from '@code-expert/prelude';

export const xpModeProps = {
  binary: null,
  proportional: null,
};
export const XpMode = iots.keyof(xpModeProps);

export type XpMode = iots.TypeOf<typeof XpMode>;

export const eqXpMode: eq.Eq<XpMode> = string.Eq;

export const defaultXp = nat.fromLiteral(100);

const viewXpModeProps = { ...xpModeProps, off: null };
export const foldViewXpMode = adt.foldFromKeys(viewXpModeProps);
export const ViewXpMode = iots.keyof(viewXpModeProps);
export type ViewXpMode = adt.TypeOfKeys<typeof foldViewXpMode>;

const BinaryGradingSettings = iots.strict({
  xpMode: iots.literal('binary'),
  minimumPoints: iots.Nat,
  maximumPoints: iots.Nat,
  xp: iots.Nat,
});

export type BinaryGradingSettings = iots.TypeOf<typeof BinaryGradingSettings>;

const ProportionalGradingSettings = iots.strict({
  xpMode: iots.literal('proportional'),
  maximumPoints: iots.Nat,
  xp: iots.Nat,
});

export type ProportionalGradingSettings = iots.TypeOf<typeof ProportionalGradingSettings>;

export const GradingSettings = iots.union([BinaryGradingSettings, ProportionalGradingSettings]);

export type GradingSettings = iots.TypeOf<typeof GradingSettings>;

export const foldGradingSettings = adt.foldFromTags<GradingSettings, 'xpMode'>('xpMode');
